<template>
  <div class="ima-inline-edit">
    <span v-if="!disabled">
      <div class="ima-inline-edit__input" contenteditable @keydown="onKeydown($event)" @blur="onBlur($event)">{{value}}</div>
      <b-icon class="ima-inline-edit__icon" icon="edit" type="is-black"></b-icon>
    </span>
    <span v-if="disabled">{{value}}</span>
  </div>
</template>


<script>
export default {
  name: 'ima-inline-edit',
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    onKeydown ($event) {
      const { key } = $event
      if (key === 'Enter') {
        $event.preventDefault()
      }
    },
    onBlur ($event) {
      const { textContent } = $event.target
      this.$emit('change', textContent.trim())
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';

.ima-inline-edit {
  display: inline;

  &__input {
    display: inline;

    &:not(:focus) {
      border-bottom: 2px dashed $secondary;
    }

    &:hover:not(:focus) {
      border-bottom: 2px dashed $highlight;
    }
  }

  &__icon {
    position: relative;
    top: -0.1em;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/InlineEdit.vue